export default {
    api: {
        host: '172.24.48.17'
    }
};



// WEBPACK FOOTER //
// ./src/configuration/config_prod.js